import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { COLORS } from '../config/colors';
import { strings } from '../strings';
import type { RootStackParamList } from '../types/navigation';
import MapIcon from './icons/MapIcon';

/**
 * Returns to the map. It sits in the top-right corner of the news/guides
 * screens.
 */
const MapButton = () => {
  const navigation =
    useNavigation<NativeStackNavigationProp<RootStackParamList>>();
  const insets = useSafeAreaInsets();

  const handlePress = () => {
    navigation.navigate('Map');
  };

  return (
    <Pressable
      accessibilityLabel={strings.openMap}
      accessibilityRole="button"
      onPress={handlePress}
      style={({ pressed }) => [
        styles.button,
        { top: insets.top + 12, right: 12 },
        pressed && styles.buttonPressed,
      ]}
    >
      <MapIcon color={COLORS.ink} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 15,
    backgroundColor: COLORS.surface,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  buttonPressed: {
    opacity: 0.8,
  },
});

export default MapButton;
